import { Fragment, ReactElement } from 'react';
import RegistrationCitizenshipNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-citizenship/detail';

const RegistrationCitizenshipNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCitizenshipNotificationCivilStatusShared />
    </Fragment>
  );
};

RegistrationCitizenshipNotificationCivilStatusPage.displayName =
  'Registration Citizenship Notification Page component';

export default RegistrationCitizenshipNotificationCivilStatusPage;
